import { useContext } from 'react';
import orgAccessContext, { Context } from './orgAccessContext';

export default (): Context => useContext(orgAccessContext);
